import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MenuItem } from 'src/app/configs/menu.config';

@Component({
  selector: 'cube-sidemenu-item',
  templateUrl: './sidemenu-item.component.html',
  styleUrls: ['./sidemenu-item.component.scss'],
})
export class SidemenuItemComponent {
  @Input() entry: MenuItem | undefined;
  @Input() iconOnly: boolean | null | undefined = false;
  @Output() clicked: EventEmitter<string> = new EventEmitter<string>();

  handleEntryClick(): void {
    if (this.entry) {
      this.entry.config.open = !this.entry?.config.open;
      this.clicked.emit(this.entry.config.link);
    }
  }
}
